import storage from './storage';

const recentBoardIds = {
	async get(mode = '') {
		if (mode !== 'extension') {
			const data = (await storage.getStorage('um/recentBoardIds')) || [];

			return data;
		} else {
			let data = null;
			if (typeof localStorage !== undefined) {
				data = localStorage.getItem('um/recentBoardIds');
			}
			//console.log(data);
			if (typeof data === 'number') {
				data = [data];
			}
			if (!data) {
				return [];
			}
			try {
				data = JSON.parse(data);
			} catch (err) {
				data = [];
			}
			return data;
		}
	},

	async set(mode = '', boardIds = []) {
		let oldBoardIds = await this.get(mode);
		//console.log(oldBoardIds);

		let maxBoardIds = 5;

		boardIds = boardIds.concat(oldBoardIds);

		if (boardIds.length > maxBoardIds) {
			boardIds.splice(0, maxBoardIds);
		}

		if (mode !== 'extension') {
			await storage.setStorage('um/recentBoardIds', JSON.stringify(boardIds));

			return boardIds;
		} else {
			localStorage.setItem('um/recentBoardIds', JSON.stringify(boardIds));
			return boardIds;
		}
	},
};

export default recentBoardIds;
